module.exports = __webpack_public_path__ + "static/media/CNY_Footer.7e85f7b4.png";